/**Dependencies */
import React from 'react'

/**Components */
import { PrincipalBanner } from '../components/PrincipalBanner';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';

/**Images */
import bannerMesa from '../images/banners/Banner principal mesa regalos.png';
import bannerPasos  from '../images/banners/pasos-mesa-regalos.png';
import bannerRegalos from '../images/banners/Banner-regalos-boda.png';

const slidesBanner = [
    { image: bannerMesa }
  ];
export const MesaRegalos = () => {
  return (
    <div className='mesa-regalos'>
        <PrincipalBanner imgsBanner={slidesBanner}/>
        <Container className='py-5'>          
            <div className="text-center mb-5">
                <h1 className='section-title outline'>Mesa de regalos</h1>                            
                <div className='py-5' style={{ width: "100%"}}>
                    <img src={bannerPasos} alt="Banner auroras boreales" style={{ width: "100%"}} />    
                    <div style={{width:'100%'}}>
                        <img src={bannerRegalos} alt="Banner auroras boreales" style={{ width: "100%"}} />     
                    </div>         
                </div>
            
            </div>                
        </Container>
        <div className='py-5'>
            <Container className="mt-5" style={{ backgroundColor: '#e13a42', padding: '20px', borderRadius: '0px' }}>
                <Row className="align-items-center">        
                    <Col md={7} className="d-flex justify-content-center align-items-center text-center">
                        <h3 style={{ color: 'white', fontSize:'40px' }}>¿Tienes alguna <br/> duda o <br/>pregunta?</h3>
                    </Col>        
                    <Col md={5}>
                        <Form style={{textAlign:'start'}}>            
                            <Form.Group className="mb-3" controlId="formName">
                            <Form.Label style={{ color: 'white' }}>Nombre Completo</Form.Label>
                            <Form.Control type="text" placeholder="" className='input-light text-white' />
                            </Form.Group>
                            
                            <Form.Group className="mb-3" controlId="formEmail">
                            <Form.Label style={{ color: 'white' }}>Correo electrónico</Form.Label>
                            <Form.Control type="email" placeholder="" className='input-light text-white'/>
                            </Form.Group>
                            
                            <Form.Group className="mb-3" controlId="formPhone">
                            <Form.Label style={{ color: 'white' }}>Número de celular</Form.Label>
                            <Form.Control type="tel" placeholder="" className='input-light text-white'/>
                            </Form.Group>
                            
                            <Row className="align-items-end">
                                <Col md={8}>
                                    <Form.Group controlId="formMessage">
                                    <Form.Label style={{ color: 'white' }}>Mensaje</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder="Escribe tu mensaje"
                                        className='input-light text-white'
                                    />
                                    </Form.Group>
                                </Col>
                                <Col md={4} className="text-end">
                                    <Button type="submit" className="btn-white mt-3 w-100">
                                    Enviar
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </div>
    </div>
  )
}
